<template>
  <div>
    <p>{{ $t("message") }}</p>
    <button @click="handle">hehe</button>
  </div>
</template>

<script>
export default {
  name: 'HelloI18n',
  methods: {
    handle () {
      this.$i18n.locale = 'en'
    }
  }
}
</script>
